import { fromJS } from 'immutable';

import { ClientId,ApiTemplate,UserToken } from '../../../helper/HelperAuth'
import {GetFlowTemplateAll} from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, client_id, division_id, sender, flow_name) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiTemplate + 'flow/list';
    // const url = 'http://localhost:9988/apitemplate/flow/list-pageable'
    if(page === undefined){
        page = 1;
    }

    var query =  {
        'client_id':(client_id === undefined ? ClientId : client_id),
        'division_id':(division_id === undefined ? '' : division_id),
        'sender':(sender === undefined ? '' : sender),
        'flow_name':(flow_name === undefined ? '' : flow_name),
        'status':'',
        'namespace' : '',
        'page': page,
        'page-size': 10,
    }

    if(search != null){
        search.map((v,k)=>{
            if(v !== ""){
                query[k] = v;
            }
        });
    }

    //debugger
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(query)
    };
    //debugger
    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        var items = [];
        data.get('data').map((item) => {                 
            items.push({
                'client_id': item.get('client_id'),
                'division_id': item.get('division_id'),
                'sender': item.get('sender'),
                'flow_id': item.get('flow_id'),
                'flow_name': item.get('flow_name'),
                'status_publish': (item.get('status') === 'PUBLISHED' ? 'true' : 'false'),
                'namespace': item.get('namespace'),
                'file_status' : ((item.get('path_file') === '' || item.get('path_file') == undefined) ? 'false' : 'true'),
            });
        });

        var data2 = {
            'row-count': data.size,
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': 1,
            'page': data.get('page'),
            'order': 'ASC',
            'data': items
        }
    }
    //debugger
    dispatch({ type: GetFlowTemplateAll, data: fromJS(data2) });
   
};